import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Row, Label, Button } from "reactstrap";
import _ from "lodash";
import mousetrap from "mousetrap";
import BookingApplicationMenu from "../../../containers/bookings/BookingApplicationMenu";
import IntlMessages from "../../../helpers/IntlMessages";
import { Colxx } from "../../../components/common/CustomBootstrap";
import Loader from "../../../components/common/Loader";
import {
  getBookingListDelta,
  getBookingListWithFilter,
  getBookingListWithOrder,
  getBookingListSearch
} from "../../../redux/booking/actions";
import DataListView from "../../../containers/bookings/DataListView";
import ListPageHeading from "../../../containers/bookings/ListPageHeading";
import ScrollButton from "../../../components/gotoTopScrollButton/ScrollButton";

function collect(props) {
  return { data: props.data };
}

class BookingApp extends Component {
  constructor(props) {
    super(props);
    this.mouseTrap = mousetrap;

    this.state = {
      thirtySecondsPassedAfterDidMount: false,
    };
  }

  componentDidMount() {
    const {
      bookingApp: { filter, orderColumn },
      getBookingListWithFilter,
      getBookingListWithOrder
    } = this.props;
    if (filter) {
      getBookingListWithFilter(filter.column, filter.value);
    }
    if (orderColumn) {
      getBookingListWithOrder(`${orderColumn.column}`, `${orderColumn.direction}`);
    }

    this.connectionTimer = setTimeout(() => {
      this.setState({ thirtySecondsPassedAfterDidMount: true });
    }, 30000);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      bookingApp: { bookingItems, filter, orderColumn },
      locale,
      getBookingListWithFilter,
      getBookingListWithOrder
    } = this.props;
    if (!this.isArrayEqual(prevProps.bookingApp.bookingItems, bookingItems) || prevProps.locale !== locale) {
      if (filter) {
        getBookingListWithFilter(filter.column, filter.value);
      }
      if (orderColumn) {
        getBookingListWithOrder(`${orderColumn.column}`, `${orderColumn.direction}`);
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.connectionTimer);
  }

  changeOrderBy = (column, direction = "asc") => {
    this.props.getBookingListWithOrder(column, direction);
  };

  handleKeyPress = e => {
    const { bookingApp, getBookingListSearch } = this.props;

    getBookingListSearch(e.target.value);
    if (bookingApp && bookingApp.orderColumn) {
      this.changeOrderBy(`${bookingApp.orderColumn.column}`, `${bookingApp.orderColumn.direction}`);
    }
  };

  isArrayEqual = (x, y) => {
    const isEqual = (obj1, obj2) => {
      return (obj1.id === obj2.id
        && obj1.created_at === obj2.created_at
        && obj1.updated_at === obj2.updated_at);
    };

    return _(x)
      .xorWith(y, isEqual)
      .isEmpty();
  };

  fetchMore = () => {
    const {
      getBookingListDelta,
      getBookingListWithFilter,
      bookingApp: { filter }
    } = this.props;
    getBookingListDelta(true);
    if (filter) {
      getBookingListWithFilter(filter.column, filter.value);
    }
  };

  loadMoreButton = () => {
    const {
      bookingApp: { bookingItems, allBookingItems, allLoaded }
    } = this.props;
    if (allLoaded) {
      return (
        <Button color="light">
          <IntlMessages id="seen_all" /> <IntlMessages id="click_to_load_number" />
          {bookingItems.length}/{Object.keys(allBookingItems).length})
        </Button>
      );
    }
    return (
      <Button color="primary" onClick={this.fetchMore}>
        <IntlMessages id="click_to_load" /> <IntlMessages id="click_to_load_number" />
        {bookingItems.length}/{Object.keys(allBookingItems).length})
      </Button>
    );
  };

  render() {
    const {
      bookingApp: { loading, orderColumn, orderColumns, searchKeyword, bookingItems: items },
      match,
      intl,
    } = this.props;

    let bookingItemList;
    if (items && items.length) {
      bookingItemList = items.map((booking, index) => (
        <DataListView
          key={booking.id}
          match={match}
          booking={booking}
          messages={intl.messages}
          collect={collect}
        />
      ));
    } else if (this.state.thirtySecondsPassedAfterDidMount || loading) {
      bookingItemList = (
        <div className="align-self-center">
          <i className="iconsminds-inbox-empty text-muted" style={{ fontSize: "25px" }} />
          <Label className="list-item-heading mb-2 text-muted">
            <IntlMessages id="booking.empty_booking_list" />
          </Label>
        </div>
      );
    } else bookingItemList = <div className="loading" />;

    return (!items
      ? (
        <div className="text-center">
          <div className="list-item-heading mb-2 text-muted px-4" style={{ fontSize: "25px" }}>
            <i className="iconsminds-inbox-empty text-muted" />
            <IntlMessages id="booking.empty_request_list" />
          </div>
        </div>
      ) : (
        <Fragment>
          <Row className="app-row survey-app">
            <Colxx xxs="12">
              {loading && <Loader />}

              <div style={{ backgroundColor: "#f8f8f8", position: "sticky", top: "3%", zIndex: "1", paddingBottom: "" }}>
                <ListPageHeading
                  heading="menu.bookings"
                  changeOrderBy={this.changeOrderBy}
                  searchKeyword={searchKeyword}
                  onChange={this.handleKeyPress}
                  orderColumn={orderColumn}
                  orderColumns={orderColumns}
                />
              </div>

              <Row className="mt-4">{bookingItemList}</Row>

              <ScrollButton className={"app-row"} />

              <div className="d-flex flex-column">{this.loadMoreButton()}</div>
            </Colxx>
          </Row>

          <BookingApplicationMenu />
        </Fragment>
      )
    );
  }
}

const mapStateToProps = ({ bookingApp, settings }) => {
  const { locale } = settings;
  return { bookingApp, locale };
};

const mapActionsToProps = {
  getBookingListDelta,
  getBookingListWithFilter,
  getBookingListWithOrder,
  getBookingListSearch,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(BookingApp)
);
